module.exports = __webpack_public_path__ + "img/Other.87bf6eb8.svg";